// Module
var code = "<div class=\"cu-sheet-low cu-p-3\"> <div class=\"cu-text-section\">Post Count By Day</div> <area-chart data=\"$ctrl.chartFormattedData\" custom-options=\"$ctrl.chartCustomOptions\"></area-chart> </div> ";
// Exports
module.exports = code;